var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/MainConnection/index.tsx";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner, Stack } from '@adc/parallax-component-library';
import { useApiError, useConnection } from 'Hooks';
import { LogoActionBar, Main, ScrollContainer } from 'Components/utility';
import { InAppActionBar } from 'Components/utility/ActionBar/InAppActionBar';
import { CONNECTIONS } from 'Reducers/connections/types';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import ConnectionCardsList from './ConnectionCardsList';
const mapStateToProps = ({
  env: {
    app
  }
}) => {
  return {
    isLibre: app === 'libre1'
  };
};
const connector = connect(mapStateToProps);
const MainConnection = ({
  isLibre
}) => {
  const {
    getConnections
  } = useConnection();
  const {
    showApiErrorModal
  } = useApiError();
  const [loading, setLoading] = useState(true);
  const [connections, setConnections] = useState();
  useEffect(() => {
    const loadConnections = async () => {
      try {
        setLoading(true);
        const connections = await getConnections();
        store.dispatch({
          type: CONNECTIONS,
          connections
        });
        setConnections(connections);
      } catch {
        showApiErrorModal();
      } finally {
        setLoading(false);
      }
    };
    loadConnections();
  }, [getConnections, showApiErrorModal]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }, isLibre ? /*#__PURE__*/React.createElement(InAppActionBar, {
    onBack: () => notifyApp('adc-webview:navigate-back-app'),
    closeBtn: true,
    title: i18n.t('Connections.title'),
    testID: "Connections",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(LogoActionBar, {
    testID: "Connections",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }), loading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    testID: "LibreLinkUp.spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 11
    }
  })) : /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: isLibre ? 0 : 115,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ConnectionCardsList, {
    connections: connections,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 11
    }
  })));
};
export default connector(MainConnection);